import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { setToken, getToken, removeToken } from "@/utils";

const token = getToken();

const initialState: IAuth = token?.accessToken
    ? { ...token, isAuthenticated: true }
    : {
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
    };

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { access, refresh } = action.payload;
            setToken({ accessToken: access, refreshToken: refresh } as IAuth);
            state.accessToken = access;
            state.refreshToken = refresh;
            state.isAuthenticated = true;
        },
        logout: (state) => {
            removeToken();
            state.accessToken = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

export const getIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const getAccessToken = (state: RootState) => state.auth.accessToken;
export const getRefreshToken = (state: RootState) => state.auth.refreshToken;
